import { render } from "./CostStandardsCurrent.vue?vue&type=template&id=e5d6f7ca&scoped=true&ts=true"
import script from "./CostStandardsCurrent.vue?vue&type=script&lang=ts"
export * from "./CostStandardsCurrent.vue?vue&type=script&lang=ts"

import "./CostStandardsCurrent.vue?vue&type=style&index=0&id=e5d6f7ca&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5d6f7ca"]])

export default __exports__